export default "__VITE_ASSET__7eebd6a2__"